var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box p-3 postal-code-search-popup" }, [
    _vm.isLoading
      ? _c("div", { staticClass: "has-text-centered" }, [
          _c("span", { staticClass: "button is-loading is-small" }, [
            _vm._v("Loading"),
          ]),
        ])
      : _c("div", [
          _c("div", { staticClass: "mb-1" }, [
            _c("h4", { staticClass: "title is-6 mb-0" }, [
              _vm._v(
                "Postal Code: " +
                  _vm._s(_vm.addressComponents?.postalCode || "N/A")
              ),
            ]),
          ]),
          _c("div", { staticClass: "box p-2 has-background-light mb-1" }, [
            _c("h5", { staticClass: "title is-6 mb-2" }, [
              _vm._v("Zone Information"),
            ]),
            _c("div", { staticClass: "columns is-multiline is-mobile" }, [
              _c("div", { staticClass: "column is-half" }, [
                _c("div", { staticClass: "field mb-1" }, [
                  _c("label", { staticClass: "label is-small mb-0" }, [
                    _vm._v("Distribution Zone"),
                  ]),
                  _c("p", { staticClass: "is-size-7 m-0" }, [
                    _vm._v(_vm._s(_vm.zoneInfo?.distributionZone || "N/A")),
                  ]),
                ]),
              ]),
              _vm._m(0),
              _c("div", { staticClass: "column is-full" }, [
                _c("div", { staticClass: "field mb-1" }, [
                  _c("label", { staticClass: "label is-small mb-0" }, [
                    _vm._v("Billable Zones"),
                  ]),
                  _vm.zoneInfo?.billableZones?.length
                    ? _c(
                        "div",
                        { staticClass: "tags-container" },
                        _vm._l(_vm.zoneInfo.billableZones, function (zone) {
                          return _c(
                            "span",
                            { key: zone, staticClass: "tag-item" },
                            [_vm._v(_vm._s(zone))]
                          )
                        }),
                        0
                      )
                    : _c("p", { staticClass: "is-size-7 m-0" }, [
                        _vm._v("N/A"),
                      ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-full" }, [
                _c("div", { staticClass: "field mb-1" }, [
                  _c("label", { staticClass: "label is-small mb-0" }, [
                    _vm._v("Clients"),
                  ]),
                  _vm.zoneInfo?.vendors?.length
                    ? _c(
                        "div",
                        { staticClass: "tags-container" },
                        _vm._l(_vm.zoneInfo.vendors, function (vendor) {
                          return _c(
                            "span",
                            { key: vendor, staticClass: "tag-item" },
                            [_vm._v(_vm._s(vendor))]
                          )
                        }),
                        0
                      )
                    : _c("p", { staticClass: "is-size-7 m-0" }, [
                        _vm._v("N/A"),
                      ]),
                ]),
              ]),
              _vm._m(1),
              _c("div", { staticClass: "column is-full" }, [
                _c("div", { staticClass: "field mb-1" }, [
                  _c("label", { staticClass: "label is-small mb-0" }, [
                    _vm._v("Payable Zones"),
                  ]),
                  _vm.zoneInfo?.payableZones?.length
                    ? _c(
                        "div",
                        { staticClass: "tags-container" },
                        _vm._l(_vm.zoneInfo.payableZones, function (zone) {
                          return _c(
                            "span",
                            { key: zone, staticClass: "tag-item" },
                            [_vm._v(_vm._s(zone))]
                          )
                        }),
                        0
                      )
                    : _c("p", { staticClass: "is-size-7 m-0" }, [
                        _vm._v("N/A"),
                      ]),
                ]),
              ]),
              _c("div", { staticClass: "column is-full" }, [
                _c("div", { staticClass: "field mb-0" }, [
                  _c("label", { staticClass: "label is-small mb-0" }, [
                    _vm._v("Contractors"),
                  ]),
                  _c("div", { staticClass: "scrollable-list" }, [
                    _vm.zoneInfo?.contractors?.length
                      ? _c(
                          "div",
                          { staticClass: "tags-container" },
                          _vm._l(
                            _vm.zoneInfo.contractors,
                            function (contractor) {
                              return _c(
                                "span",
                                { key: contractor, staticClass: "tag-item" },
                                [_vm._v(_vm._s(contractor))]
                              )
                            }
                          ),
                          0
                        )
                      : _c("p", { staticClass: "is-size-7 m-0" }, [
                          _vm._v("N/A"),
                        ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "box p-2 has-background-light mb-1 days-of-service",
            },
            [
              _c("h5", { staticClass: "title is-6 mb-2" }, [
                _vm._v("Days of Service"),
              ]),
              _c(
                "div",
                { staticClass: "columns is-multiline is-mobile" },
                _vm._l(_vm.daysOfService, function (day, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "column is-one-third" },
                    [
                      _c("div", { staticClass: "field m-0" }, [
                        _c("label", { staticClass: "checkbox" }, [
                          _c("input", {
                            attrs: { type: "checkbox", disabled: _vm.isSaving },
                            domProps: { checked: day.enabled },
                            on: {
                              change: function ($event) {
                                return _vm.toggleDay(index)
                              },
                            },
                          }),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(_vm._s(day.name)),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _vm.message
            ? _c(
                "div",
                {
                  staticClass: "notification is-small mb-1",
                  class: _vm.messageClass,
                },
                [_vm._v(" " + _vm._s(_vm.message) + " ")]
              )
            : _vm._e(),
          _c("div", { staticClass: "field is-grouped is-grouped-right mt-1" }, [
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-small is-success",
                  class: { "is-loading": _vm.isSaving },
                  staticStyle: { "border-radius": "5px" },
                  attrs: { disabled: _vm.isSaving },
                  on: { click: _vm.handleSave },
                },
                [_vm._v(" Save ")]
              ),
            ]),
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-small",
                  staticStyle: { "border-radius": "5px" },
                  attrs: { disabled: _vm.isSaving },
                  on: { click: _vm.handleClose },
                },
                [_vm._v(" Cancel ")]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-full m-0" }, [
      _c("hr", { staticClass: "m-0" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-full m-0" }, [
      _c("hr", { staticClass: "m-0" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }